import { useCursorPages, type PagedResponse } from '@/components/templates/list-pager'
import {
  Pagination,
  PaginationContent,
  PaginationItem,
  PaginationNext,
  PaginationPrevious,
} from '@/components/ui/pagination'
import type { EmailSend } from './EmailLogTable'

interface EmailSendsResponse extends PagedResponse {
  email_sends: EmailSend[]
}

const EMAIL_SENDS_PAGE_SIZE = 50

export function useEmailSendPages(path: string) {
  const { query, pager } = useCursorPages<EmailSendsResponse>({
    queryKey: ['email-sends'],
    path,
    limit: EMAIL_SENDS_PAGE_SIZE,
  })
  const move = (event: React.MouseEvent<HTMLAnchorElement>, step: () => void) => {
    event.preventDefault()
    step()
  }
  const pagination =
    pager && (pager.hasPrevious || pager.hasNext) ? (
      <Pagination aria-label="Email history pages" aria-busy={pager.busy} className="p-3">
        <PaginationContent>
          {pager.hasPrevious && (
            <PaginationItem>
              <PaginationPrevious
                href="#"
                aria-disabled={pager.busy}
                onClick={(event) => move(event, pager.previous)}
              />
            </PaginationItem>
          )}
          {pager.hasNext && (
            <PaginationItem>
              <PaginationNext
                href="#"
                aria-disabled={pager.busy}
                onClick={(event) => move(event, pager.next)}
              />
            </PaginationItem>
          )}
        </PaginationContent>
      </Pagination>
    ) : null
  return { query, pagination }
}
